<template>
	<div class="cassie-vertical-md mt-1">
		<FilterBar
			:search-query.sync="filters.systemName"
			search-query-label="Integration System Name"
			hide-brand-filter
		>
			<template #after-filters>
				<TextField
					v-model="filters.connectionName"
					label="Connection Name"
					clearable
				/>
			</template>
		</FilterBar>

		<SectionCard>
			<template #title>
				Connection Service Failures
			</template>
			<template #body>
				<DataTable
					:headers="computedTableHeaders"
					:items="filteredFailures"
					:items-per-page="100"
					sort-by="responseDate"
					sort-desc
					hide-default-footer
					height="70vh"
					@click:row="openResponseModal"
				>
					<template #item.responseMessage="{ item }">
						<span>
							{{ truncateMessage(item.responseMessage, 25) }}
						</span>
					</template>

					<template #item.action="{ item }">
						<v-menu
							v-if="integrationFailures.hasPii"
							offset-y
							left
						>
							<template #activator="{ on, attrs }">
								<v-btn
									icon
									v-bind="attrs"
									v-on="on"
									@click.stop
								>
									<v-icon>
										mdi-dots-horizontal
									</v-icon>
								</v-btn>
							</template>
							<v-list dense>
								<v-list-item
									@click="openResponseModal(item)"
								>
									<v-list-item-title>
										View Full Response Message
									</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
				</DataTable>
			</template>
		</SectionCard>

		<Modal
			v-if="integrationFailures.hasPii && showResponseModal"
			width="800px"
		>
			<template #modal-title>
				FailureID: {{ openFailureId }}
				<v-spacer />
				<IconButton @click="closeResponseModal">
					mdi-close
				</IconButton>
			</template>
			<template #modal-content>
				<div class="cassie-vertical-md">
					<vue-json-pretty
						v-if="validJson"
						:data="rawResponseMessage"
					/>
					<div v-else>
						{{ rawResponseMessage }}
					</div>
				</div>
			</template>
			<template #modal-footer>
				<SecondaryActionButton @click="closeResponseModal">
					Close
				</SecondaryActionButton>
			</template>
		</Modal>
	</div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import FilterBar from '../../../../../../shared/components/filter-bar.vue'
import SectionCard from '../../../../../../shared/components/section-card.vue'
import DataTable from '../../../../../../shared/components/data-table.vue'
import Modal from '../../../../../../shared/components/modal.vue'
import SecondaryActionButton from '../../../../../../shared/components/secondary-action-button.vue'
import IconButton from '../../../../../../shared/components/icon-button.vue'
import TextField from '../../../../../../shared/components/text-field.vue'

export default {
	components: { DataTable, SectionCard, Modal, SecondaryActionButton, VueJsonPretty, IconButton, FilterBar, TextField },
	props: {
		integrationFailures: {
			type: Object,
			default: () => ({ hasPii: false, failures: [] })
		}
	},
	data () {
		return {
			filters: {
				systemName: '',
				connectionName: ''
			},
			showResponseModal: false,
			rawResponseMessage: null,
			openFailureId: null,
			validJson: false,
			ableHeaders: []
		}
	},
	computed: {
		filteredFailures () {
			return this.integrationFailures.failures?.filter(failure => {
				const systemNameMatch = this.filters?.systemName
					? failure.systemName?.toLowerCase().includes(this.filters.systemName?.toLowerCase())
					: true

				const connectionNameMatch = this.filters.connectionName
					? failure.integration?.toLowerCase().includes(this.filters.connectionName?.toLowerCase())
					: true

				return systemNameMatch && connectionNameMatch
			})
		},
		computedTableHeaders () {
			const baseHeaders = [
				{ value: 'failureID', text: 'ID', width: '10%' },
				{ value: 'systemName', text: 'System Name', width: '20%' },
				{ value: 'integration', text: 'Service Name', width: '20%' },
				{ value: 'responseDate', text: 'Response Date', width: '20%' },
				{ value: 'responseCode', text: 'Response Code', width: '10%' }
			]

			if (this.integrationFailures.hasPii) {
				baseHeaders.push(
					{ value: 'responseMessage', text: 'Response Message', width: '20%' },
					{ value: 'action', text: 'Action', width: '80px', align: 'center', sortable: false }
				)
			}

			return baseHeaders
		}
	},
	methods: {
		truncateMessage (message, length) {
			return message?.length > length ? `${message.substring(0, length)}...` : message || ''
		},
		openResponseModal (item) {
			if (!this.integrationFailures.hasPii) {
				this.showResponseModal = false
			}
			this.openFailureId = item.failureID
			try {
				this.rawResponseMessage = JSON.parse(item.responseMessage)
				this.validJson = true
			} catch {
				this.rawResponseMessage = item.responseMessage
				this.validJson = false
			}
			this.showResponseModal = true
		},
		closeResponseModal () {
			this.showResponseModal = false
			this.rawResponseMessage = null
			this.openFailureId = null
			this.validJson = false
		}
	}
}
</script>
